export function groupProcedures(procedures, sites = [], departments = []) {
  const groups = new Map();
  for (const procedure of procedures.filter((item) => item.active !== false)) {
    const siteId = procedure.site_id || "";
    const departmentId = procedure.department_id || "";
    const site = sites.find((item) => item.id === siteId);
    const department = [...departments, ...(site?.departments || [])].find((item) => item.id === departmentId && (!item.site_id || item.site_id === siteId));
    if (!groups.has(siteId)) groups.set(siteId, {
      id: siteId, name: site?.name || procedure.site_name || "Sede non disponibile", departments: new Map(), count: 0,
    });
    const group = groups.get(siteId);
    if (!group.departments.has(departmentId)) group.departments.set(departmentId, {
      id: departmentId,
      name: !departmentId ? "Intera sede" : department?.name || procedure.department_name || "Reparto non disponibile",
      procedures: [],
    });
    group.departments.get(departmentId).procedures.push(procedure);
    group.count += 1;
  }
  const compare = (a, b) => a.name.localeCompare(b.name, "it");
  return [...groups.values()].sort(compare).map((site) => ({
    ...site,
    departments: [...site.departments.values()].sort((a, b) => !a.id ? -1 : !b.id ? 1 : compare(a, b))
      .map((department) => ({ ...department, procedures: [...department.procedures].sort((a, b) => (a.name || "").localeCompare(b.name || "", "it")) })),
  }));
}
